import React, { useEffect, useId, useMemo, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';
import logoImage from '../../assets/images/logo-david.png';

function Header() {
  const navLinkClass = ({ isActive }) => isActive ? 'nav-link-active' : undefined;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileMenuQuery, setMobileMenuQuery] = useState('');
  const mobileMenuId = useId();

  const navItems = useMemo(() => ([
    { to: '/', label: 'Home', end: true },
    { to: '/about', label: 'About' },
    { to: '/programs', label: 'Programs' },
    { to: '/admissions', label: 'Admissions' },
    { to: '/resources', label: 'Resources' },
    { to: '/contact', label: 'Contact' },
  ]), []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setMobileMenuQuery('');
  };

  useEffect(() => {
    if (!isMobileMenuOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeMobileMenu();
    };

    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileMenuOpen]);

  const filteredNavItems = useMemo(() => {
    const q = mobileMenuQuery.trim().toLowerCase();
    if (!q) return navItems;
    return navItems.filter((i) => i.label.toLowerCase().includes(q));
  }, [mobileMenuQuery, navItems]);

  return (
    <header className={`site-header ${isMobileMenuOpen ? 'is-mobileMenuOpen' : ''}`}>
      <div className="header-inner">
        <div className="header-left">
          <button
            type="button"
            className="header-menuButton"
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls={mobileMenuId}
            onClick={() => setIsMobileMenuOpen((v) => !v)}
          >
            <span className="header-menuIcon" aria-hidden="true" />
          </button>
          <Link to="/" className="header-logo" onClick={closeMobileMenu}>
            <span className="logo-icon" aria-hidden="true">
              <img src={logoImage} alt="" />
            </span>
            <span className="logo-text">
              {/* <span className="logo-title">THE DAVID FOSTER</span>
              <span className="logo-academy">ACADEMY</span> */}
            </span>
            {/* <span className="logo-tagline">PRESCHOOL | KINDERGARTEN | AFTERSCHOOL</span> */}
          </Link>
        </div>
        <nav className="header-nav" aria-label="Main navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={navLinkClass}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header-actions">
          <Link
            to={{ pathname: '/admissions', hash: 'schedule-tour' }}
            className="header-cta"
            onClick={closeMobileMenu}
          >
            Schedule Tour
          </Link>
        </div>
      </div>
      <div
        id={mobileMenuId}
        className={`header-mobileOverlay ${isMobileMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
        onClick={closeMobileMenu}
      >
        <nav
          className="header-mobilePanel"
          aria-label="Mobile navigation"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="header-mobilePanelTop">
            <Link to="/" className="header-mobilePanelLogo" onClick={closeMobileMenu} aria-label="Home">
              <img src={logoImage} alt="The David Foster Academy" />
            </Link>
            <button
              type="button"
              className="header-mobileClose"
              aria-label="Close menu"
              onClick={closeMobileMenu}
            >
              ×
            </button>
          </div>

          {/* <div className="header-mobileSearch">
            <input
              type="search"
              value={mobileMenuQuery}
              onChange={(e) => setMobileMenuQuery(e.target.value)}
              placeholder="Search Here"
              aria-label="Search menu"
            />
            <button type="button" aria-label="Search" className="header-mobileSearchBtn">
              <span aria-hidden="true">▢</span>
            </button>
          </div> */}

          <div className="header-mobileLinks" role="list">
            {filteredNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={navLinkClass}
                onClick={closeMobileMenu}
                role="listitem"
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
      <div className="header-line" aria-hidden="true" />
    </header>
  );
}

export default Header;
